const addAllFilterToEachFilterCategory = ({ filterCategory, _acc }) => {
  if (filterCategory === 'formatOfDeliveryAndEventSupport') _acc[filterCategory]['All Format/Support Options'] = true;
  if (filterCategory === 'activityLocation') _acc[filterCategory]['All Locations'] = true;
  if (filterCategory === 'themes') _acc[filterCategory]['All Themes'] = true;
  if (filterCategory === 'county') _acc[filterCategory]['All Counties'] = true;
  if (filterCategory === 'region') _acc[filterCategory]['All Regions'] = true;
};

export default addAllFilterToEachFilterCategory;
